import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:false,
    token:'',
    userInfo:{},
    isExpert:false,
    userId:''
  },
  mutations: {
    UPDATE_IsLogin(state, val) {
      state.isLogin = val
    },
    UPDATE_TOKEN(state, val) {
      state.token = val
    },
    UPDATE_USERINFO(state, val) {
      state.userInfo = val
    },
    UPDATE_ISEXPERT(state, val) {
      state.isExpert = val
    },
  },
  actions: {
  },
  modules: {

  }
})
